<template>
    <layout v-slot="layoutScope" title="Nuestros productos">
        <div id="primary" class="content-area">
            <div id="primary" class="content-area">
                <main id="main" class="site-main">
                    <div class="cont maincont">

                        <div class="section-top">

                            <h1 class="maincont-ttl">Productos</h1>
                            <ul class="b-crumbs">
                                <li><inertia-link href="/">Inicio</inertia-link></li>
                                <li>Productos</li>
                            </ul>
                        </div>

                        <!-- To make Sidebar "Not Sticky" just remove  id="section-list-withsb" -->
                        <div class="section-wrap-withsb">
                            <aside class="blog-sb-widgets section-sb" id="section-sb">
                                <div class="theiaStickySidebar">
                                    <p class="section-filter-toggle filter_hidden">
                                        <a href="#" id="section-filter-toggle-btn">Mostrar filtros</a>
                                    </p>
                                    <div class="section-filter">
                                        <div class="section-filter">
                                            <div class="blog-sb-widget multishopcategories_widget">
                                                <h3 class="widgettitle">Categorías</h3>
                                                <div class="section-sb-current">
                                                    <ul class="section-sb-list">
                                                        <li>
                                                            <inertia-link
                                                                :href="`/productos`"
                                                                :class="layoutScope.isCurrentPath('/productos') ? 'active' : ''"
                                                            >
                                                                <span class="section-sb-label">Todos los productos <span class="count">{{ totalProducts }}</span></span>
                                                            </inertia-link>
                                                        </li>
                                                        <li v-for="category in _categories" :key="category.id">
                                                            <inertia-link
                                                                :href="`/categorias/${category.slug}/productos`"
                                                                :class="(layoutScope.currentPathContains('categorias') && layoutScope.currentPathContains(category.slug)) ? 'active' : ''"
                                                            >
                                                                <span class="section-sb-label">{{ category.name }} <span class="count">{{ category.products_count }}</span></span>
                                                            </inertia-link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>


                                            <div v-if="_featuredProducts.length" class="blog-sb-widget multishopfeaturedproducts_widget">
                                                <h3 class="widgettitle">Destacados</h3>
                                                <div class="products-featured-wrap">

                                                    <div v-for="product in _featuredProducts" :key="product.id" class="products-featured">
                                                        <p class="products-featured-categ">
                                                            <inertia-link :href="`/categorias/${product.category.slug}/productos`">{{ product.category.name }}</inertia-link>
                                                        </p>
                                                        <h5 class="products-featured-ttl"><a :href="`/productos/${product.slug}`">{{ product.name }}</a></h5>
                                                        <p class="products-featured-price">${{ product.price }}</p>
                                                    </div>

                                                </div>
                                            </div>
                                            <!-- <div class="blog-sb-widget multishopbrands_widget">
                                                <h3 class="widgettitle">Brands</h3>
                                                <ul class="brands-list-sb">
                                                    <li>
                                                        <a href="#">HOOK <span class="count">5</span></a>
                                                    </li>
                                                    <li>
                                                        <a href="#">Fuel Tank <span class="count">7</span></a>
                                                    </li>
                                                    <li>
                                                        <a href="#">BMP <span class="count">17</span></a>
                                                    </li>
                                                    <li>
                                                        <a href="#">BISON <span class="count">9</span></a>
                                                    </li>
                                                    <li>
                                                        <a href="#">AIR <span class="count">6</span></a>
                                                    </li>
                                                </ul>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                            </aside>        <div class="section-list-withsb" id="section-list-withsb">
                            <div class="theiaStickySidebar">

                                <div class="row prod-items prod-items-2">

                                    <article v-for="product in _products.data" :key="product.id" class="cf-sm-6 cf-md-6 cf-lg-6 col-xs-6 col-sm-6 col-md-6 col-lg-6 sectgl-item">
                                        <div class="sectgl prod-i">
                                            <div class="prod-i-top">
                                                <inertia-link class="prod-i-img" :href="`/productos/${product.slug}`">
                                                    <img v-if="product.images && product.images.length" :src="`/storage/${product.images[0]}`" :alt="product.name">
                                                </inertia-link>
                                                <!-- <p class="prod-i-badge"><span class="badge-2">Top seller</span></p> -->
                                            </div>
                                            <div class="prod-i-bot">
                                                <div class="prod-i-info">
                                                    <p class="prod-i-price">${{ product.price }}</p>
                                                    <p v-if="product.category" class="prod-i-categ"><a :href="`/categorias/${product.category.slug}/productos`">{{ product.category.name }}</a></p>
                                                </div>
                                                <h3 class="prod-i-ttl"><inertia-link :href="`/productos/${product.slug}`">{{ product.name }}</inertia-link></h3>
                                                <add-to-cart-single :product="product"></add-to-cart-single>
                                            </div>
                                        </div>
                                    </article>

                                </div>
                                <paginator
                                    :next-page-url="_products.next_page_url"
                                    :prev-page-url="_products.prev_page_url"
                                    :last-page="_products.last_page"
                                    :current-page="_products.current_page"
                                    :path="_products.path"
                                ></paginator>
                            </div><!-- .theiaStickySidebar -->
                        </div><!-- .section-list-withsb -->
                        </div><!-- .section-wrap-withsb -->

                    </div>
                </main><!-- #main -->
            </div>
        </div>
    </layout>
</template>

<script>
import Layout from '../Layout';
import AddToCartSingle from '../../components/Cart/AddToCartSingle';
import Paginator from '../../components/Paginator';

export default {
    components: {
        Layout,
        Paginator,
        AddToCartSingle,
    },
    props: {
        _products: Object,
        _categories: Array,
        _featuredProducts: Array,
    },

    computed: {
        totalProducts() {
            return this._categories.reduce((total, category) => total + category.products_count, 0)
        },
    }
}
</script>

<style>

</style>
